import React from 'react';
import { useTranslation } from 'react-i18next';
import useExcelStyles from '../useExcelStyles';
import useNoRowsTemplate from '../useNoRowsOverlay';
import useLoadingOverlay from '../useLoadingOverlay';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { setDialogMode, openDialog, setConditionOrdinary } from '../../../redux/slices/condition';
import { TOOLTIP_SHOW_DELAY } from '../../../constants';
import type { ConditionDetailType } from '../../../types/condition';
import type { ExcelStyle, GetContextMenuItemsParams, GridOptions, MenuItemDef } from 'ag-grid-community';

const useGridOptionsConditionOrdinary = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { commonExcelStyles } = useExcelStyles();
  const { condition, selectedViewMode } = useSelector((state: RootState) => state.condition);

  // Excelのスタイル設定
  // ----------------------------------------
  const excelStyles: ExcelStyle[] = [...commonExcelStyles];

  // Overlayの設定
  // ----------------------------------------
  const overlayLoadingTemplate: string = useLoadingOverlay();
  const overlayNoRowsTemplate: string = useNoRowsTemplate();

  // rowNodeIdの設定
  // ----------------------------------------
  const getRowNodeId = (params: ConditionDetailType): string => {
    return String(params.id);
  };

  // 右クリックメニューの設定
  // ----------------------------------------
  const getContextMenuItems = (params: GetContextMenuItemsParams): (string | MenuItemDef)[] => {
    // console.log(params);
    if (params.node) {
      const data: ConditionDetailType = params.node.data;
      dispatch(setConditionOrdinary(data.id));
      const editMenu = {
        name: t('edit'),
        action: () => {
          dispatch(setDialogMode('UPDATE'));
          dispatch(openDialog());
        },
      };
      const deleteMenu = {
        name: t('delete'),
        action: () => {
          dispatch(setDialogMode('DELETE'));
          dispatch(openDialog());
        },
      };

      // 編集ビューの場合のみ編集メニューを表示
      if (selectedViewMode === 'EDITING' && condition?.conditionStatus === 'EDITING') {
        const menuItems = [editMenu, deleteMenu, 'separator', 'export'];
        return menuItems;
      } else {
        const menuItems = ['export'];
        return menuItems;
      }
    } else {
      return [];
    }
  };

  // GridOptions全体
  // ----------------------------------------
  const gridOptions: GridOptions = {
    allowContextMenuWithControlKey: true,
    enableRangeSelection: true,
    excelStyles,
    getContextMenuItems,
    getRowNodeId,
    overlayLoadingTemplate,
    overlayNoRowsTemplate,
    tooltipShowDelay: TOOLTIP_SHOW_DELAY,
  };

  return { gridOptions };
};

export default useGridOptionsConditionOrdinary;
